import { LoadingService } from '../../../../shared/services/loading/loading.service';

export const customerTabLoadingService = new LoadingService();
